import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  coverImage: string;
  date: string;
  readTime: string;
  viewCount: number;
  category: string;
}

const categoryMap: Record<string, string> = {
  shipin: '视频资源',
  shequ: '社区讨论',
  wenzhang: '文章资讯',
  huati: '话题标签',
  ziyuan: '资源合集',
};

export default function ArticleCard({ slug, title, excerpt, coverImage, date, readTime, viewCount, category }: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-colors group cursor-pointer">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img src={coverImage} alt={title} title={`${title} - 挠脚心vk`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy" />
          <span className="absolute top-3 left-3 bg-primary-500 text-background-50 text-xs px-2 py-1 rounded-md whitespace-nowrap">
            {categoryMap[category] || category}
          </span>
        </div>
        <div className="p-4 md:p-5">
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
            {title}
          </h3>
          <p className="text-sm text-foreground-600 mb-3 line-clamp-2">{excerpt}</p>
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1"><i className="ri-calendar-line"></i>{date}</span>
            <span className="flex items-center gap-1"><i className="ri-time-line"></i>{readTime}</span>
            <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{viewCount.toLocaleString()}</span>
          </div>
        </div>
      </Link>
    </article>
  );
}